// Libraries
import { ReactNode } from 'react';

// Hooks
import { useAppDispatch } from '../../../app/hooks';

// Features
import { clearModalContent } from '../../../features/app/appSlice';

// Components
import Button from '../../atoms/Button/Button';
import ModalContent from './ModalContent';

// Constants
import { ERROR_GENERIC } from '../../../utils/constants/constants';

/**
 * @function ModalContentGeneric
 * Describe the ModalContentGeneric's function
 *
 * @example
 * return (
 *   <ModalContentGeneric />
 * )
 */
function ModalContentGeneric(): JSX.Element {
    const dispatch = useAppDispatch();

    function handleCloseClick() {
        dispatch(clearModalContent());
    }

    return (
        <ModalContent>
            <>
                <h2>
                    Sorry, <b>something</b> went wrong
                </h2>
                <p>{ERROR_GENERIC}, please try again soon.</p>
                <Button
                    text="Back to <b>Lobby</b>"
                    style="primary"
                    onClick={() => handleCloseClick()}
                />
            </>
        </ModalContent>
    );
}

// Exports
export default ModalContentGeneric;
